export default "__VITE_ASSET__9znIIxLr__"